export const formatPhoneNumber = (phoneNumber?: string): string => {
    if (!phoneNumber) {
        return '';
    }
    return phoneNumber
        .replace('+33', '0')
        .match(/.{1,2}/g)
        ?.join(' ') as string;
};
